export default __webpack_public_path__ + "static/media/huma-sevansusnaves-cover.0b368286.jpg";